window.ACF_RETARGET_CONFIG = {
  "version": "acf-rt-20261027",
  "currency": "USD",
  "enabled": false,
  "approvals": {
    "pricing": true,
    "warehouse": false,
    "integrationSeparation": false,
    "checkout": false
  },
  "packs": {
    "3": {
      "handle": "copy-of-advanced-crepe-fix-1-jar",
      "productId": 8362463756573,
      "variantId": 45089678557469,
      "sku": "MMACF-3",
      "price": 12900,
      "fulfillmentVerified": false,
      "subscription": {
        "handle": "copy-of-advanced-crepe-fix-1-jar",
        "variantId": 45089678557469,
        "planId": 691050119453,
        "price": 10300,
        "interval": "MONTH",
        "intervalCount": 3,
        "policyVerified": true,
        "evidence": "Recharge saved MONTH 3; public allocation verified 2026-10-27; evidence/approved-changes/three-jar-product.json"
      }
    },
    "6": {
      "handle": "copy-of-advanced-crepe-fix-3-jars",
      "productId": 8362464149789,
      "variantId": 45089679540509,
      "sku": "MMACF-6",
      "price": 24000,
      "fulfillmentVerified": false,
      "subscription": {
        "handle": "copy-of-advanced-crepe-fix-3-jars",
        "variantId": 45089679540509,
        "planId": 691050086685,
        "price": 19200,
        "interval": "MONTH",
        "intervalCount": 6,
        "policyVerified": true,
        "evidence": "Recharge saved MONTH 6; public allocation verified 2026-10-27; evidence/approved-changes/six-jar-product.json"
      }
    },
    "1": {
      "handle": "advanced-crepe-fix",
      "productId": 8336468836637,
      "variantId": 45018555416861,
      "sku": "MMACF-1",
      "price": 4900,
      "fulfillmentVerified": false,
      "subscription": {
        "handle": "advanced-crepe-fix",
        "variantId": 45018555416861,
        "planId": 691050152221,
        "price": 3900,
        "interval": "MONTH",
        "intervalCount": 1,
        "policyVerified": true,
        "evidence": "Recharge saved MONTH 1; public allocation verified 2026-10-27; evidence/approved-changes/one-jar-product.json"
      }
    }
  },
  "addons": [
    {
      "handle": "miamimd-instant-wrinkle-eraser-1-bottle-special",
      "productId": 15485379182877,
      "variantId": 67912012398877,
      "sku": "MMIWE-1B",
      "title": "MiamiMD Instant Wrinkle Eraser 1 Bottle (Special)",
      "image": "assets/acfup-iwe.png",
      "price": 3300,
      "catalogPriceCents": 3300,
      "catalogFamily": "special",
      "enabled": false,
      "fulfillmentVerified": false,
      "publicPlanReadbackVerified": false,
      "pricingApproved": true
    },
    {
      "handle": "miamimd-total-beauty-matrix-1-jar-special",
      "productId": 15485392257309,
      "variantId": 67912160608541,
      "sku": "MMTBM-1B",
      "title": "MiamiMD Total Beauty Matrix 1 Jar (Special)",
      "image": "assets/acfup-tbm.png",
      "price": null,
      "catalogPriceCents": 3300,
      "catalogFamily": "special",
      "enabled": false,
      "fulfillmentVerified": false,
      "publicPlanReadbackVerified": false
    },
    {
      "handle": "miamimd-facial-cleanser-1-tube-special",
      "productId": 15485375807773,
      "variantId": 67911977369885,
      "sku": "MMFC-1B",
      "title": "MiamiMD Facial Cleanser 1 Tube (Special)",
      "image": "assets/acfup-cleanser.png",
      "price": null,
      "catalogPriceCents": 2730,
      "catalogFamily": "special",
      "enabled": false,
      "fulfillmentVerified": false,
      "publicPlanReadbackVerified": false
    },
    {
      "handle": "miamimd-lip-plumper-1-bottle-special",
      "productId": 15485384884509,
      "variantId": 67912075903261,
      "sku": "MMLP-1B",
      "title": "MiamiMD Lip Plumper 1 Bottle (Special)",
      "image": "assets/acfup-lip.png",
      "price": null,
      "catalogPriceCents": 3300,
      "catalogFamily": "special",
      "enabled": false,
      "fulfillmentVerified": false,
      "publicPlanReadbackVerified": false
    },
    {
      "handle": "miamimd-dark-spot-corrector-1-bottle-special",
      "productId": 15485350543645,
      "variantId": 67911687602461,
      "sku": "MMDSC-1B",
      "title": "MiamiMD Dark Spot Corrector 1 Bottle (Special)",
      "image": "assets/acfup-dsc.png",
      "price": null,
      "catalogPriceCents": 3300,
      "catalogFamily": "special",
      "enabled": false,
      "fulfillmentVerified": false,
      "publicPlanReadbackVerified": false
    }
  ],
  "catalogRegistryVersion": "emanuel-catalog-20261029"
};
